import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import { AuthorLine as AuthorLineLeshenUI } from '@leshen/ui'

const AuthorLine = ({ publishDate, firstName, lastName }) => {
  const blog = useStaticQuery(graphql`
    query AuthorLineQuery {
      site {
        siteMetadata {
          blog {
            urls {
              root
              author
            }
          }
        }
      }
    }
  `)

  const root = blog.site.siteMetadata?.blog?.urls?.root || '/blog'
  const path = blog.site.siteMetadata?.blog?.urls?.author || '/author'
  const authorPath = `/${firstName?.toLowerCase()?.replace(' ', '-')}-${lastName
    ?.toLowerCase()
    ?.replace(' ', '-')}`
  const authorRootPath = `${root}${path}${authorPath}`

  return (
    <AuthorLineLeshenUI
      publishDate={publishDate}
      firstName={firstName}
      lastName={lastName}
      authorLink={authorRootPath}
    />
  )
}

export default AuthorLine
